module.exports = `${require.publicPath}avatar.8c1886a0.png`;